import { AssetFundAssetList } from '@/views/UserCenter/components/Assets/AssetFundAssetList'
import { useBaseInfoStore, useKlineStore } from 'store'
import '../styles/position-list-layout.scss'

export const PositionList = defineComponent({
  name: 'PositionList',
  setup() {
    const baseInfoStore = useBaseInfoStore()
    const klineStore = useKlineStore()

    const currentSymbolInfo = computed(() => {
      if (!klineStore.currentSymbolId) return null
      const info = baseInfoStore.getCoinStaticItemDataBySymbolId(klineStore.currentSymbolId)
      return info
    })

    return () => {
      return (
        <div class="position-list-layout">
          <AssetFundAssetList isHolding coinFromItemId={currentSymbolInfo.value?.coinFrom} coinToItemId={currentSymbolInfo.value?.coinTo} />
        </div>
      )
    }
  },
})
